import { Link } from 'react-router'
import { cn } from '@/lib/utils'
import { Navigation, Footer } from '../components'

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-white font-sans overflow-x-hidden flex flex-col">
      <Navigation />

      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-20">
        <div className="max-w-lg mx-auto text-center">
          <div className="mb-8">
            <span className="text-8xl sm:text-9xl font-bold text-orange-primary/20">
              404
            </span>
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight text-neutral-900 mb-4">
            Page not found
          </h1>

          <p className="text-base sm:text-lg text-neutral-500 mb-8 max-w-md mx-auto leading-relaxed">
            Sorry, we couldn't find the page you're looking for. It might have
            been moved or doesn't exist.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/"
              className={cn(
                'w-full sm:w-auto',
                'bg-orange-primary text-white',
                'px-7 sm:px-8 py-3.5 rounded-full',
                'flex items-center justify-center',
                'hover:bg-orange-hover',
                'hover:-translate-y-0.5',
                'transition-all duration-200',
                'active:translate-y-0',
                'text-base font-semibold'
              )}
            >
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  )
}
